"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var ResponsiveVideo = function ResponsiveVideo(props) {
  var src = props.src,
      className = props.className,
      allowFullScreen = props.allowFullScreen,
      aspectRatio = props.aspectRatio;
  var wrapperClassName = (0, _classnames.default)('video-responsive', "video-responsive-".concat(aspectRatio), className && className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: src,
    allowFullScreen: allowFullScreen
  }));
};

ResponsiveVideo.ASPECT_RATIO_4_BY_3 = '4by3';
ResponsiveVideo.ASPECT_RATIO_16_BY_9 = '16by9';
ResponsiveVideo.defaultProps = {
  aspectRatio: ResponsiveVideo.ASPECT_RATIO_16_BY_9,
  allowFullScreen: true
};
ResponsiveVideo.propTypes = {
  src: _propTypes.default.string.isRequired,
  aspectRatio: _propTypes.default.oneOf([ResponsiveVideo.ASPECT_RATIO_4_BY_3, ResponsiveVideo.ASPECT_RATIO_16_BY_9]),
  allowFullScreen: _propTypes.default.bool
};
var _default = ResponsiveVideo;
exports.default = _default;